export const textItemsFromField = (item:{text:string}[], callback:(text:string, index:number) => any) => 
    item && item.map(({text}:{text:string}, index) => callback(text, index));

// A Prismic link field is empty ('Any') or broken when it has no usable destination
export const hasLink = (field:any) => !!field && !!field.link_type && field.link_type !== 'Any' && field.isBroken !== true;
